import { z } from 'zod'

export const couponTypeSchema = z.enum([
  'couponCode',
  'giftcardCode',
  'voucherCode',
])
